/** @jsxImportSource @emotion/react */
import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Formulario, useEstetica } from "../../shared";
import { accessAPI } from "../../shared";
import { Card } from "primereact/card";
import logoVerticalBlanco from "../../images/logoVerticalBlanco.png";
import { Toast } from "primereact/toast";
import { Boton } from "../../shared";

export default function RegistroEmpresa() {
  const estetica = useEstetica();
  const [formLoader, setFormLoader] = useState(false);
  const [confirmacionRegistro, setConfirmacionRegistro] = useState(false);

  const navigate = useNavigate();

  const toast = useRef(null);

  const registroEmpresaFormConfig = {
    secciones: [
      {
        nombre: "Datos de la empresa",
        campos: [
          {
            nombre: "razonsocial",
            tipoitemformularioid: 1,
            etiqueta: "Razón social",
            requerido: true
          },
          {
            nombre: "tipoIdentificadorId",
            tipoitemformularioid: 5,
            etiqueta: "Tipo de identificador",
            opciones: "cliente/tipoidentificador",
            sinOpcionInicial: true
          },
          {
            nombre: "rut",
            tipoitemformularioid: 1,
            etiqueta: "Identificador"
          },
          {
            nombre: "direccion",
            tipoitemformularioid: 1,
            etiqueta:
              "Dirección, IMPORTANTE: especifique dirección de puerta, código postal, ciudad y país",
            requerido: true,
            notas:
              "Morfeo estructura la dirección automáticamente, por eso debe incluir la información completa"
          },
          {
            nombre: "telefono",
            tipoitemformularioid: 1,
            etiqueta: "Teléfono"
          }
        ]
      },
      {
        nombre: "Responsable de certificación",
        descripcion:
          "Usuario principal que gestionará los certificados desde esta plataforma. Puede actualizarse en caso de ser necesario.",
        campos: [
          {
            nombre: "nombreresponsable",
            tipoitemformularioid: 1,
            etiqueta: "Nombre",
            requerido: true
          },
          {
            nombre: "apellidoresponsable",
            tipoitemformularioid: 1,
            etiqueta: "Apellido",
            requerido: true
          },
          {
            nombre: "emailresponsable",
            tipoitemformularioid: 2,
            etiqueta: "Email",
            requerido: true
          },
          {
            nombre: "telefonoresponsable",
            tipoitemformularioid: 1,
            etiqueta: "Celular",
            requerido: true
          },
          {
            nombre: "cargoresponsable",
            tipoitemformularioid: 1,
            etiqueta: "Cargo"
          }
        ]
      }
    ],
    botones: [
      {
        etiqueta: "Enviar",
        validar: true,
        callback: crearEmpresa
      },
      {
        etiqueta: "Cancelar",
        transparente: true,
        callback: () => {
          navigate("/");
        }
      }
    ]
  };

  function crearEmpresa(camposFormulario) {
    setFormLoader(true);
    accessAPI(
      "POST",
      "cliente",
      camposFormulario,
      (response) => {
        setConfirmacionRegistro(true);
        setFormLoader(false);
      },
      (response) => {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail:
            response[0]?.msg ||
            "Ocurrió un error, intente nuevamente más tarde.",
          sticky: true
        });
        setFormLoader(false);
      }
    );
  }

  return (
    <main
      css={{
        paddingBottom: "50px",
        minHeight: "calc(100vh - var(--alturaFooter))"
      }}
    >
      <Toast ref={toast} position="top-center" />
      <div css={{ marginBottom: "50px" }}>
        <div
          css={{
            paddingTop: "50px",
            marginBottom: "30px",
            width: "100%",
            marginLeft: "auto",
            marginRight: "auto"
          }}
        >
          <img
            css={{
              width: "150px",
              marginLeft: "auto",
              marginRight: "auto",
              display: "block"
            }}
            // El logo en blanco del organismo; si no cargó uno, el de la
          // plataforma.
          src={estetica?.logos?.blanco || logoVerticalBlanco}
            alt="logo"
          />
        </div>
        {!confirmacionRegistro && (
          <Card
            css={{
              width: "800px",
              marginLeft: "auto",
              marginRight: "auto",
              marginBottom: "50px",
              padding: "30px 0px"
            }}
          >
            <Formulario
              config={registroEmpresaFormConfig}
              loader={formLoader}
              formularioEnCuerpo
            />
          </Card>
        )}
      </div>

      {confirmacionRegistro && (
        <Card
          css={{
            width: "800px",
            marginLeft: "auto",
            marginRight: "auto",
            marginBottom: "50px",
            padding: "30px 0px"
          }}
        >
          <div css={{ textAlign: "center" }}>
            <p>Su empresa ha sido registrada exitosamente.</p>
            <p>
              Les crearemos una cuenta y recibirá un correo con instrucciones
              para el ingreso.
            </p>
            <p>
              Muchas gracias por confiar en{" "}
              {estetica?.nombre || "nuestro organismo certificador"}.
            </p>
            <Boton transparente callback={() => navigate("/")}>
              Volver al login
            </Boton>
          </div>
        </Card>
      )}
    </main>
  );
}
